import React, { useState, useEffect, useRef } from "react";
import { FaChevronLeft, FaChevronUp, FaCommentAlt, FaMinus, FaPlus, FaShoppingCart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import axios from "axios";
import { decreaseCountFromCart, addToCart } from "../../Redux/Actions";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import CommentModal from "../../components/CommentModal/CommentModal";
import { Config } from "../../Config";
import Tags from "../../components/Tags/Tags";
import GSlider from "../../components/GSlider/GSlider";
import StopWatch from "../../assets/images/stopWatch.svg";
import Guarantee from "../../assets/images/guarant.svg";
import Club from "../../assets/images/club.svg";
import Comments from "../../components/Comments/Comments";
import Skeleton from "react-loading-skeleton";
import Service from "../../components/Service/Service";
import "./ProductSingle.scss";
import "./Responsive.scss";
import "react-toastify/dist/ReactToastify.css";

const ProductSingle = (props) => {
  let productId;
  let productName;
  let pathLength = props.history.location.pathname.split("/");
  if (!pathLength[3]) {
    props.history.push("/404");
  } else {
    productName = pathLength[3];
  }

  if (!pathLength[2]) {
    props.history.push("/404");
  } else {
    productId = pathLength[2];
  }
  const descRef = useRef(null);
  const showMoreRef = useRef(null);
  const [product, setProduct] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [shopCount, setShopCount] = useState(0);
  const [preloader, setPreloader] = useState(true);
  const [productServices, setProductServices] = useState([]);
  const [allProductServices, setAllProductServices] = useState([]);
  const [comments, setComments] = useState([]);
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const [resetPage, setResetPage] = useState({ state: false, count: 0 });
  const user = useSelector((state) => state.user);
  const [provinces, setProvinces] = useState(null);
  const [cities, setCities] = useState(null);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  // const breadCrumbData = [
  //   { title: "خانه", link: "/" },
  //   { title: "محصولات", link: "/products" },
  //   { title: `${product && product.productName}` },
  // ];

  useEffect(async () => {
    Config.pageUp();
    await getSingleProduct(productName.replaceAll("-", " "));
    await getProductServices(productId);
    await getAllComments(productId);
    await getProvinces();
    if (cart.find((item) => item.id === productId)) {
      const item = cart?.find((item) => item.id === productId);
      setShopCount(item.count);
    }

    if (cart.length <= 0) {
      setShopCount(0);
    }
  }, [props.location.state !== undefined && props.location.state.productId, cart, resetPage.state]);

  const getProvinces = async () => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        "Content-type": "application/json",
      },
    };
    // await fetch(`${Config.apiPath2}/providerApi/getProvinces`, requestOptions)
    await fetch(`${Config.apiPath}/api/Provinces`, requestOptions)
      .then(async (response) => {
        if (response.status == 200) {
          let resJosn = await response.json();
          //console.log("response", response);
          //console.log("resJosn", resJosn);
          setProvinces(resJosn.data);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const getCityHandler = (id) => {
    let requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    // fetch(`${Config.apiPath2}/providerApi/getCities?provinceId=${id}`, requestOptions)
    fetch(`${Config.apiPath}/api/Cities/GetCityWithFilter/${id}`, requestOptions)
      .then(async (response) => {
        if (response.status == 200) {
          let resJosn = await response.json();
          console.log("======>", resJosn);
          setCities(resJosn.data);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (!preloader) {
      // console.log(descRef.current.clientHeight);
      if (descRef.current.clientHeight > 200) {
        descRef.current.style.maxHeight = "200px";
        showMoreRef.current.style.display = "block";
      } else {
        showMoreRef.current.style.display = "none";
        descRef.current.style.maxHeight = "unset";
      }
    }
  }, [preloader]);

  const getSingleProduct = async (id) => {
    if (resetPage.count == 0) {
      setPreloader(true);
    }
    axios
      .get(
        `/Product/GetProduct/${id}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setProduct(result.data.data);
        setResetPage({ state: resetPage.state, count: resetPage.count + 1 });
        setPreloader(false);
      })
      .catch((error) => {
        setPreloader(false);
        props.history.push("/404");
        // console.log("error", error);
      });
  };

  const getProductServices = async (id) => {
    axios
      .get(`/Product/GetProductStores/${id}`)
      .then((result) => {
        setProductServices(result.data.data);
        setAllProductServices(result.data.data);
        // console.log("result.data.data", result.data.data);
        setResetPage({ state: resetPage.state, count: resetPage.count + 1 });
        setPreloader(false);
      })
      .catch((error) => {
        setPreloader(false);
        props.history.push("/404");
        // console.log("error", error);
      });
  };

  const clearInforms = () => {
    setCities(null);
    setProductServices(allProductServices);
  };

  const getAllComments = async (id) => {
    axios
      .get(
        `/Product/GetProductComments/${id}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setComments(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const cartCountPlus = (productId) => {
  //   // const item = allProducts.find(item => item.id === productId);
  //   setResetPage({ state: resetPage.state, count: resetPage.count + 1 });
  //   const cartItem = cart.find((item) => item.id === productId);
  //   if (shopCount < product.count) {
  //     // dispatch(addToCart(item));
  //     let count = shopCount + 1;
  //     setShopCount(shopCount + 1);
  //     cartAddRemoveHandler("update", cartItem, cartItem.orderDetailId, count);
  //   }
  // };

  // const cartCountMinus = (productId) => {
  //   // const item = allProducts.find(item => item.id === productId);
  //   setResetPage({ state: resetPage.state, count: resetPage.count + 1 });
  //   const cartItem = cart.find((item) => item.id === productId);
  //   let count = shopCount - 1;
  //   setShopCount(shopCount - 1);
  //   cartAddRemoveHandler("delete", cartItem, cartItem.orderDetailId, count);
  //   // dispatch(decreaseCountFromCart(item));
  // };

  // const cartAddRemoveHandler = (action, item, orderDetailId, count) => {
  //   let myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

  //   let raw = JSON.stringify({
  //     Id: orderDetailId,
  //     Count: count,
  //   });

  //   let requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(Config.apiPath + "/orders/CommandOrderDetail", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (action === "delete") {
  //         dispatch(decreaseCountFromCart(item));
  //       } else if (action === "update") {
  //         dispatch(addToCart(item));
  //       }
  //       // console.log(result);
  //     })
  //     .catch((error) => console.log("error", error));
  // };

  // const addToCartHandler = (productId) => {
  //   if (user.length > 0) {
  //     // const item = allProducts?.find((item) => item.id === productId);
  //     // addToCartServer(user[0]?.token, item, productId, 1);
  //     let requestOptions = {
  //       method: "GET",
  //       redirect: "follow",
  //     };

  //     fetch(Config.apiPath + `/Product/GetProduct/${productId}`, requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         if (result.status === 200) {
  //           // const selectProduct = allProducts.find((item) => item.id == product.id);
  //           // addToCartServer(user[0]?.token, selectProduct, product.id, 1);
  //           const product = {
  //             id: result.data.id,
  //             image: result.data.productImage,
  //             description: result.data.description,
  //             name: result.data.productName,
  //             price: result.data.unitPrice,
  //             pageCount: "",
  //             weight: "",
  //             hasGuruanty: "",
  //             guruantyType: "",
  //             guruantyMonth: "",
  //             guruantyDetail: "",
  //             hasDiscount: "",
  //             discount: result.data.discount,
  //             finalPrice: result.data.finalPrice,
  //             discountDetail: result.data.discountDetail,
  //             point: result.data.point,
  //             count: result.data.count,
  //             isInstallments: "",
  //           };
  //           addToCartServer(user[0]?.token, product, product.id, 1);
  //         } else {
  //           toast.error(<div>{result.messages}</div>);
  //         }
  //       })
  //       .catch((error) => console.log("error", error));
  //   } else {
  //     props.history.push("/login");
  //   }
  // };

  // const addToCartServer = (token, product, productId, count) => {
  //   let myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", `Bearer ${token}`);

  //   let raw = JSON.stringify({
  //     productId: productId,
  //     providerId: ,
  //     Count: count,
  //     isApprovedPrice:,
  //   });

  //   let requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(Config.apiPath + "/orders/addtocart", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.status === 200) {
  //         let newProduct = Object.assign(product, { orderDetailId: result.data.orderDetailId });
  //         dispatch(addToCart(newProduct));
  //         // dispatch(addToCart(item));
  //         setShopCount(shopCount + 1);
  //       } else {
  //         toast.error(<div>{result.messages}</div>);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  const showCommentModal = () => {
    let body = document.body;
    body.style.overflowY = "hidden";
    setCommentModal(true);
  };

  const hideCommentModal = () => {
    let body = document.body;
    body.style.overflowY = "auto";
    setCommentModal(false);
  };

  const commentSubmitHandler = (commentText, recaptcha) => {
    if (recaptcha !== "") {
      setShowSpinner(true);
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

      let raw = JSON.stringify({
        ProductId: productId,
        Message: commentText,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/Product/sendMessage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            toast.success(<div>{result.messages}</div>);
            getAllComments(productId);
            setShowSpinner(false);
            setCommentModal(false);
            // setResetPage(!resetPage);
            setResetPage({ state: !resetPage.state, count: resetPage.count + 1 });
          }
        })
        .catch((error) => {
          setShowSpinner(false);
          // console.log("error", error);
        });
    } else {
      toast.error("گزینه من ربات نیستم فعال نیست!");
      setShowSpinner(false);
    }
  };

  const showMoreDesc = (e) => {
    // let desc = document.querySelector(".productLeftBox .description");
    if (descRef.current.clientHeight <= 200) {
      setShowMoreDescription(true);
      descRef.current.style.maxHeight = "100%";
    } else {
      setShowMoreDescription(false);
      descRef.current.style.maxHeight = "200px";
    }
  };

  const setFilter = (type, id) => {
    if (type === "province") {
      let title = provinces.filter((i) => i.nstwProvinceId === parseInt(id));
      let filtered = allProductServices.filter((i) => i.province === title[0].name);
      console.log("filtered", filtered);
      setProductServices(filtered);
    } else {
      console.log("cities", cities);
      let title = cities.filter((i) => i.id === id);
      console.log("title", title);
      let filtered = allProductServices.filter((i) => i.city === title[0].title);
      console.log("filtered", filtered);
      setProductServices(filtered);
    }
  };
  // console.log(product);
  return (
    <section className="singleProductWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | {`${product?.productName}`}</title> */}
        <title>
          {product?.productName ? `${Config.helmetTitle} | ${`${product?.productName}`}` : `${Config.helmetTitle}`}
          {/* {Config.helmetTitle} | {`${product?.productName}`} */}
        </title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && <Preloader active={preloader} />} */}
      {/* <BreadCrumb breadCrumbData={breadCrumbData} /> */}
      <div className="productContents">
        <div className="desktop">
          <div className="stickyHelper">
            <div className="productImagesBox">
              {!product || !product.gallery ? (
                <Skeleton
                  containerClassName="imageGalleryWrapper"
                  className="skeleton zoomSkeleton"
                  // style={{ minHeight: "500px" }}
                  highlightColor={Config.skeletonHighlightColor}
                />
              ) : (
                <div className="imageGalleryWrapper">
                  <GSlider images={product.gallery} />
                </div>
              )}
              {!product || !product.productName ? (
                <Skeleton
                  containerClassName="title"
                  className="skeleton"
                  highlightColor={Config.skeletonHighlightColor}
                  style={{ minHeight: "50px" }}
                />
              ) : (
                <p className="title">{product && product.productName}</p>
              )}
              {!product ||
                (!product.description && (
                  <Skeleton
                    containerClassName="description"
                    className="skeleton"
                    style={{ minHeight: "35px", width: "50%" }}
                    highlightColor={Config.skeletonHighlightColor}
                  />
                ))}
              <p className="description" ref={descRef}>
                {product && product.description}
              </p>

              <span className="showDescMore" ref={showMoreRef} onClick={(e) => showMoreDesc(e)}>
                {showMoreDescription ? (
                  <span>
                    بستن <FaChevronUp />
                  </span>
                ) : (
                  <span>
                    مشاهده بیشتر <FaChevronLeft />
                  </span>
                )}
              </span>
            </div>
          </div>
          <div className="productLeftBox">
            <div className="topTitle">
              <Service
                data={productServices}
                productId={productId}
                productName={productName}
                product={product}
                locations={{ provinces: provinces, cities: cities }}
                getCityHandler={getCityHandler}
                clearInforms={clearInforms}
                setFilter={setFilter}
              />
            </div>
            <div className="tools">
              {product.hasGuarantee && (
                <div className="toolsImage">
                  <img src={Guarantee} alt="Guarantee" />
                  <div className="toolsModal">
                    <p className="title">{product && product.guaranteeName}</p>
                    <p className="toolsTime">{product && product.guaranteeMonth} ماهه</p>
                    <p className="description">{product && product.guaranteeDescription}</p>
                  </div>
                </div>
              )}
              {product.point > 0 && (
                <div className="toolsImage">
                  <img src={Club} />
                </div>
              )}
            </div>
            {/* <div className="amount">
              {product.count > 0 && product.hasDiscount && (
                <div className="amountDetails">
                  <span className="discount">
                    <span className="dTime">
                      <img src={StopWatch} alt="StopWatch" /> {product.discountDetail}
                    </span>{" "}
                    &nbsp;تا پایان تخفیف &nbsp;<span className="dOff">{product.discount}</span>
                  </span>
                  <div className="discountPriceBox">
                    <p className="discountPrice">
                      قیمت کل : <span className="off">{Config.separate(product.unitPrice)} ریال</span>
                    </p>
                  </div>
                </div>
              )}
              <div className="amountBox">
                {shopCount > 0 ? (
                  <React.Fragment>
                    {product && product.count && (
                      <div className="amountInnerBox">
                        <div className="amountCount">
                          <FaPlus className="fa-plus" onClick={() => cartCountPlus(product.id)} />
                          <input
                            className="amountCountInput"
                            disabled
                            value={shopCount}
                            min="1"
                            max={product.count}
                            type="number"
                            name=""
                          />
                          <FaMinus className="fa-minus" onClick={() => cartCountMinus(product.id)} />
                        </div>
                        <p className="stockCount">
                          تعداد موجودی: <span>{product && product.count}</span>
                        </p>
                      </div>
                    )}
                    {!product || !product.finalPrice ? (
                      <Skeleton
                        containerClassName="totalPrice"
                        className="skeleton"
                        style={{ minWidth: "80px", minHeight: "30px" }}
                        highlightColor={Config.skeletonHighlightColor}
                      />
                    ) : (
                      <p className="totalPrice">
                        قیمت تمام شده : <span>{Config.separate(product.finalPrice)} ریال</span>
                      </p>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {/* {product && product.count && (
                      <div className="amountInnerBox">
                        <button className="addToCart" onClick={() => addToCartHandler(product.id)}>
                          <FaShoppingCart /> افزودن به سبد خرید
                        </button>
                        <p className="stockCount">
                          تعداد موجودی: <span>{product && product.count}</span>
                        </p>
                      </div>
                    )} */}
            {/* {!product || !product.finalPrice ? (
                      <Skeleton
                        containerClassName="totalPrice"
                        className="skeleton"
                        style={{ minWidth: "80px", minHeight: "30px" }}
                        highlightColor={Config.skeletonHighlightColor}
                      />
                    ) : (
                      <p className="totalPrice">
                        قیمت تمام شده : <span>{Config.separate(product.finalPrice)} ریال</span>
                      </p>
                    )}
                  </React.Fragment>
                )}
              </div> */}
            {/* </div> */}
            {product.keys !== undefined && product.keys.length > 0 && <Tags tagData={product && product.keys} />}
          </div>
          <div className="optionWrapper">
            {product.options !== undefined && product.options.length > 0 && (
              <div className="options">
                <p className="title">ویژگی ها</p>
                {product.options &&
                  product.options.map((item, index) => {
                    return (
                      <div className="optionItems" key={index}>
                        <p className="optionItem">
                          <span className="optionKey">{item.key} :</span>
                          <span className="optionValue">{item.value}</span>
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>

          <div className="comments">
            <p className="title">
              <FaCommentAlt /> دیدگاه کاربران ({comments.length})
            </p>
            {user.length > 0 ? (
              <button className="showCommentModal" onClick={(e) => showCommentModal(e)}>
                ارسال دیدگاه
              </button>
            ) : (
              <p className="loginWarning">برای ارسال دیدگاه باید وارد حساب کاربری خود شوید</p>
            )}
            <Comments commentData={comments} />
          </div>
        </div>
      </div>
      {commentModal && (
        <CommentModal
          show={commentModal}
          showSpinner={showSpinner}
          submitHandler={commentSubmitHandler}
          hideCommentModal={hideCommentModal}
        />
      )}
    </section>
  );
};

export default React.memo(withRouter(ProductSingle));
